import medals from 'assets/images/medals/medals.webp';
import Achievements, {AchievementsColorName} from 'components/Achievements';
import {Button, Modal} from 'components/ui';
import React, {useState} from 'react';
import getCompetenceTitle from 'utils/functions/getCompetenceTitle';
import {getAchievementsSize} from 'utils/functions/ReviewSideBar';
import {MappedCompetences} from '..';
import styles from './Standards.module.scss';

interface ModalStandardsData {
  title: string;
  subTitle: string;
  description: string;
}

interface OwnProps {
  competences: MappedCompetences[];
  cycleType: number | undefined;
  showComments: boolean;
}

export type Props = OwnProps;

const Standards: React.FC<Props> = ({
  competences,
  cycleType = 0,
  showComments,
}) => {
  const [modalAchievements, setModalAchievements] = useState(false);
  const [modalStandards, setModalStandards] = useState(false);
  const [modalStandardsData, setModalStandardsData] =
    useState<ModalStandardsData>();

  const handleModalAchievements = () => {
    setModalAchievements(!modalAchievements);
  };

  const handleModalStandards = (
    competence?: MappedCompetences,
    cycleType?: number,
  ) => {
    if (competence) {
      setModalStandardsData({
        title: getCompetenceTitle(competence.name, 0),
        subTitle: getCompetenceTitle(competence.name, 1),
        description:
          cycleType === 2
            ? competence?.studentCompetenceDescription
            : competence?.studentCompetenceDescriptionCycleOne,
      });
    }
    setModalStandards(!modalStandards);
  };
  return (
    <>
      <>
        <div className={styles.title}>
          <h1>Critérios</h1>
        </div>
        <div>
          {competences.map((competence: MappedCompetences, index: number) => (
            <div className={styles.card} key={String(index)}>
              <div className={styles.cardContentWrapper}>
                <div className={styles.cardHeader}>
                  <div className={styles.leftContent}>
                    <h4 className={styles.cardTitle}>
                      {getCompetenceTitle(competence.name, 0)}
                    </h4>
                    <p className={styles.cardSubtitle}>
                      {getCompetenceTitle(competence.name, 1)}
                    </p>
                    {showComments && competence.comments && (
                      <p
                        className={styles.comment}
                        data-testid="competenceComment"
                        dangerouslySetInnerHTML={{__html: competence.comments}}
                      />
                    )}
                  </div>
                  <div className={styles.rightContent}>
                    <button
                      type="button"
                      className={styles.medalButton}
                      onClick={() =>
                        handleModalStandards(competence, cycleType)
                      }
                    >
                      O que é isso?
                    </button>
                  </div>
                </div>
                <div className={styles.medal}>
                  <Achievements
                    cycle={cycleType || 0}
                    level={competence.level}
                    type="medals"
                  />
                  <span>MEDALHA</span>
                  <p className={styles.medalDescription}>
                    {AchievementsColorName(competence.level)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.medalsModalButton}>
          {cycleType === 2 && (
            <Button
              onClick={handleModalAchievements}
              variant="secondary"
              text="O que são as medalhas?"
            />
          )}
        </div>
      </>
      <Modal
        title="LISTA DE TROFÉUS"
        isOpen={modalAchievements}
        onClose={handleModalAchievements}
        clickOutsideToClose
      >
        <div className={styles.modal}>
          <img className={styles.modalHeader} src={medals} alt="Achievements" />
          <p className={styles.modalDescription}>
            As medalhas estão associadas aos critérios de correção e mostram as
            diferentes habilidades que foram alcançadas em cada um. Assim, você
            receberá uma das medalhas abaixo, para cada critério de correção,
            sempre que finalizar uma redação na Letrus, o que irá te ajudar a
            compreender melhor a sua evolução em cada um dos critérios.
          </p>
          <div className={styles.modalImage}>
            {[1, 2, 3, 4, 5].map((item, index) => (
              <Achievements
                cycle={cycleType || 0}
                type="medals"
                level={item}
                size={getAchievementsSize()}
                key={index.toString()}
              />
            ))}
          </div>
        </div>
      </Modal>
      <Modal
        title="O QUE É ISSO?"
        isOpen={modalStandards}
        onClose={() => handleModalStandards()}
        clickOutsideToClose
      >
        <div className={styles.modalStandards}>
          <div className={styles.modalStandardsHeader}>
            <div className={styles.modalStandardsTitle}>
              {modalStandardsData?.title}
            </div>
            <div className={styles.modalStandardsSubtitle}>
              {modalStandardsData?.subTitle}
            </div>
          </div>
          <div className={styles.modalStandardsSubtitle}>
            {modalStandardsData?.description}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Standards;
